import { ADMIN, ADMIN_PROFILE } from '@services/authent/authent.api';

import { DenormalizedProfile, GroupWithUsers, NormalizedGroup, Profile } from '@/types/authent/groups.types';
import { User } from '@/types/authent/login.types';

export function isRestrictedProfile(profile: DenormalizedProfile | Profile) {
  return profile.name === ADMIN_PROFILE;
}

export function isRestrictedGroup(group: GroupWithUsers | NormalizedGroup) {
  return group.code === ADMIN_PROFILE;
}

export function isRestrictedUser(user: User) {
  return user.login === ADMIN;
}

export function generateDuplicateName(originalName: string, existingNames: Set<string>): string {
  const baseName = `${originalName}-copy`;
  let newName = baseName;
  let counter = 2;

  while (existingNames.has(newName)) {
    newName = `${baseName}${counter}`;
    counter++;
  }

  return newName;
}
